import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as Icons from "lucide-react";
import { api } from "../lib/api";

const Icon = ({ name, ...p }) => {
  const C = Icons[name] || Icons.Sparkles;
  return <C {...p} />;
};

export default function Projetos() {
  const [projects, setProjects] = useState([]);
  const loc = useLocation();

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data));
  }, []);

  useEffect(() => {
    if (loc.hash) {
      const id = loc.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 200);
    }
  }, [loc.hash, projects]);

  return (
    <div data-testid="page-projetos" className="pt-24 md:pt-32 bg-[#FAF9F6]">
      <header className="max-w-7xl mx-auto px-6 md:px-10 pb-16 md:pb-20">
        <div className="text-[11px] uppercase tracking-[0.28em] text-[#003F88] font-semibold">
          <span className="accent-line" />
          Projetos para Lauro de Freitas
        </div>
        <h1 className="font-serif-display text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6">
          Dezessete áreas, <em className="italic font-light">uma cidade inteira</em>.
        </h1>
        <p className="mt-6 max-w-3xl text-base md:text-lg text-neutral-600 font-light leading-relaxed">
          A íntegra das frentes de trabalho que Antônio Rosalvo conduziu em três mandatos como
          vereador — incluindo a presidência da Câmara Municipal — reeditada a partir das revistas
          institucionais “Prestando Contas” e “Proposições do Vereador Rosalvo”.
        </p>
      </header>

      <div className="bg-white border-y border-neutral-200">
        {projects.map((p, idx) => (
          <article
            key={p.id}
            id={p.id}
            data-testid={`projeto-detail-${p.id}`}
            className={`border-b border-neutral-200 last:border-0 py-20 md:py-24 ${idx % 2 === 1 ? "bg-[#FAF9F6]" : "bg-white"}`}
          >
            <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-10">
              <div className="lg:col-span-4">
                <div className="flex items-center gap-4">
                  <span className="inline-flex items-center justify-center w-14 h-14 bg-[#003F88] text-[#FFC72C]">
                    <Icon name={p.icon} size={26} strokeWidth={1.5} />
                  </span>
                  <div className="text-[11px] uppercase tracking-[0.22em] text-[#003F88] font-semibold">
                    {p.area}
                  </div>
                </div>
                <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl leading-tight mt-6 text-neutral-900">
                  {p.title}
                </h2>
              </div>
              <div className="lg:col-span-8">
                <p className="text-base md:text-lg text-neutral-700 font-light leading-relaxed">
                  {p.description}
                </p>
                <ul className="mt-8 grid md:grid-cols-2 gap-x-10 gap-y-4">
                  {p.highlights.map((h, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm md:text-base text-neutral-700">
                      <span className="mt-2 inline-block w-2 h-2 bg-[#FFC72C] shrink-0" />
                      <span>{h}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
